import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Darttemplate from "../../component/course/dart";

export default class Dartinnagercoil extends Component {
 
  render() {
    
    const title = "Dart Programming"   
    const url ="dart"
    const url1 ="-training-in-nagercoil"
    const location = "nagercoil" 
    const location1="Training in Nagercoil" 
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Learn Dart programming from Learnsoft, a leading training institute in ${location}. Our Dart programming training program is designed to help you gain expertise in this modern, object-oriented programming language developed by Google. Our experienced trainers provide practical training and real-world projects to help you gain hands-on experience. Enroll now and become a certified Dart professional to jumpstart your career in app development.`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Darttemplate url={url} title={title} url1={url1} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
